'use strict';

var chip = {};

exports.__exports = chip;
//# sourceMappingURL=chip.cjs.map
